document.addEventListener("DOMContentLoaded", function () {
	tippy("[data-tippy-content]", {
		...bds_theme.features.tooltips.tippy_opts,
	});
});
